export type ViewportTransform = [number, number, number, number, number, number];

export function isViewportTransform(
  viewportTransform: number[],
): viewportTransform is ViewportTransform {
  return viewportTransform.length === 6;
}
